import Card from "./card";

const CardGrid = ({info})=>{
    return (
        <>
            <main className="cards-main">
                <section className="cards-grid">
                    {info.map((item, index) => <Card key={index} sectionName={item.sectionName} image={item.image} text={item.text} side={item.side} title={item.title} id={item.id}/>)}

                </section>
            </main>
        </>
    )
}

export default CardGrid